import * as React from 'react';
import Input, {InputProps} from 'components/Input';
import styled, {css} from 'styled-components';
import {transparentize} from 'polished';
import {IconSearch} from 'icons';
import {Theme} from '../stores/AppStore';

export const Container = styled.label`
  width: 100%;
  display: inline-block;
  position: relative;
`;

export const IconWrapper = styled.div`
  user-select: none;
  align-items: center;
  display: inline-grid;
  position: absolute;
  top: 0;
  right: 20px;
  bottom: 0;
  margin: auto;

  ${({theme}) => {
    switch (theme.name) {
      case Theme.Dark: return css`
        color: ${({theme}) => `
          ${transparentize(.7, theme.colors.white)};
        `}; 
      `;
      case Theme.Light: return css`
        color: ${({theme}) => theme.variables.color}; 
      `;
    }
  }};
  
  svg {
    fill: currentColor;
  }
`;

/**
 * The input search component
 * @param {InputProps} props
 * @return {React.ReactElement<InputProps>}
 * @constructor
 */
export default function InputSearch(
    props: InputProps,
): React.ReactElement<InputProps> {
  return (
    <Container>
      <Input {...props} />
      <IconWrapper>
        <IconSearch />
      </IconWrapper>
    </Container>
  );
}
